import * as React from "react";
import { OutletContextProps } from "../../helpers/RouterHelper";
import enhanceSectionsSettingsPage from "../../hocs/enhanceSectionsSettingsPage";
import { useFetchKarteTemplates } from "../../hooks/http/useFetchKarteTemplates";
import { useQueryError } from "../../hooks/http/useQueryError";
import SectionInterface from "../../interfaces/SectionInterface";
import SectionsSettingsKarteTemplates from "./SectionsSettingsKarteTemplates";

interface Props extends OutletContextProps {
  section: SectionInterface;
}

const SectionsSettingsKarteTemplatesPage: React.FC<Props> = (props) => {
  React.useEffect(() => {
    props.setActiveMenu("template");
  }, []);

  const {
    data: karteTemplates,
    error,
    isPending,
  } = useFetchKarteTemplates({
    sectionId: props.section.id,
  });
  useQueryError(error);

  return (
    <SectionsSettingsKarteTemplates
      section={props.section}
      karteTemplates={karteTemplates ?? []}
      isLoading={isPending}
    />
  );
};

const pageInfo = {
  title: "テンプレート",
};

export default enhanceSectionsSettingsPage(
  SectionsSettingsKarteTemplatesPage,
  pageInfo,
);
